import { createQueryKeys } from '@lukemorales/query-key-factory';
import {
  getAssistants,
  getTaskByStoreId,
  getTodoList,
  GetTodoListParams,
  getTodoUserConfig,
} from 'views/Conversation/Sider/ToDoBundle/api';
import { todoStatusList, todoTypeList } from 'views/Todo/service';

export const tickets = createQueryKeys('tickets', {
  list: (params: GetTodoListParams) => ({
    queryKey: [params],
    queryFn: ({ signal }) => getTodoList(params, signal),
  }),
  statusList: (taskId: number) => ({
    queryKey: [taskId],
    queryFn: ({ signal }) => todoStatusList(taskId, signal),
  }),
  task: (storeId: string) => ({
    queryKey: [storeId],
    queryFn: async ({ signal }) => {
      const result = await getTaskByStoreId(storeId, signal);
      // React Query 不允许返回 undefined，当 API 返回空数据时提供默认值
      return result ?? { task: undefined, policies: [] };
    },
  }),
  assistants: (storeId: string) => ({
    queryKey: [storeId],
    queryFn: ({ signal }) => getAssistants(storeId, signal),
  }),
  userConfig: {
    queryKey: null,
    queryFn: ({ signal }) => getTodoUserConfig(signal),
  },
  typeList: (taskId: string) => ({
    queryKey: [taskId],
    queryFn: ({ signal }) => todoTypeList({ taskId }, signal),
  }),
});
